<script>
import Config from '@/config';
import FormMinx from '@/mixins/form';
import AdminMinx from '@/mixins/admin';
import {Popup, DatetimePicker, Picker, RadioGroup, Radio, Stepper, Toast} from 'vant';
import {getStationBaseInfo, getStationStockType, getStationStockNum, getStationStockRecordDetail, createStationStockRecord} from '@/api';

export default {
  mixins: [
    FormMinx,
    AdminMinx
  ],
  components: {
    [Popup.name]: Popup,
    [DatetimePicker.name]: DatetimePicker,
    [Picker.name]: Picker,
    [RadioGroup.name]: RadioGroup,
    [Radio.name]: Radio,
    [Stepper.name]: Stepper
  },
  data() {
    return {
      stationName: '',
      stockTypes: [],

      registerAt: null,
      registerGoodsName: null,
      registerReason: null,
      registerType: null,
      registerNum: 1,
      recordPeople: null,
      stockNum: 0,

      showPicker: false
    };
  },
  computed: {
    stockId() {
      return this.$route.params.stockId;
    },
    stationCode() {
      return this.$route.params.stationCode;
    },
    readonly() {
      return !!this.$route.params.stockId;
    }
  },
  watch: {
    stationCode(value) {
      this.loadStationData(value);
    },
    stockId(value) {
      this.loadStockData(value);
    },
    registerGoodsName(value) {
      if (!value) {
        return;
      }
      getStationStockNum(this.stationCode, this.stockTypes.find(v => v.value === value).key).then(response => {
        this.stockNum = response.data.body;
      });
    }
  },
  created() {
    getStationStockType().then(response => {
      this.stockTypes = response.data.body;
    });

    this.loadStationData(this.stationCode);
    this.loadStockData(this.stockId);
  },
  methods: {
    loadStationData(value) {
      if (value) {
        getStationBaseInfo(value).then(response => {
          this.stationName = response.data.body.name;
        });
      } else {
        this.stationName = null;
      }
    },
    loadStockData(value) {
      this.showPicker = false;
      this.showDatetimePicker = false;

      if (value) {
        getStationStockRecordDetail(value).then(response => {
          this.registerAt = response.data.body.registerAt;
          this.registerGoodsName = response.data.body.registerGoodsName;
          this.registerReason = response.data.body.registerReason;
          this.registerType = response.data.body.registerType;
          this.registerNum = response.data.body.registerNum;
          this.recordPeople = response.data.body.recordPeople;
        });
      } else {
        this.registerAt = null;
        this.registerGoodsName = null;
        this.registerReason = null;
        this.registerType = null;
        this.registerNum = 1;
        this.recordPeople = null;
      }
    },
    onSubmit(values) {
      if (this.registerType === 2 && this.stockNum < this.registerNum) {
        Toast('没有足够的库存来发放');
        return;
      }
      createStationStockRecord(this.stationCode, Object.assign(values, {registerGoodsType: this.stockTypes.find(v => v.value === this.registerGoodsName).key})).then(response => {
        if (response.data.code === Config.successCode) {
          Toast('登记库存记录成功');
          this.$router.go(-1);
        } else {
          Toast('登记库存记录失败');
        }
      }).catch(() => Toast('登记库存记录失败'));
    },
    showRegisterAtDatetimePicker() {
      if (this.readonly) {
        return;
      }

      this.showDatetimePicker = true;
    },
    pickerOnConfirm(value) {
      this.showPicker = false;
      this.registerGoodsName = value.value;
    },
    datetimePickerOnConfirm(datetime) {
      this.showDatetimePicker = false;
      this.registerAt = datetime.format('yyyy-MM-dd hh:mm');
    }
  }
}
</script>

<template>
  <van-form @submit="onSubmit" :show-error-message="false">
    <div class="row-title">{{ stationName }}</div>
    <van-field :value="registerAt" name="registerAt" label="登记时间" placeholder="点击选择等级时间" @click="showRegisterAtDatetimePicker" :rules="[{ validatorDatetime }]" :readonly="readonly" clickable/>
    <van-field :value="registerGoodsName" name="registerGoodsName" label="选择品类" placeholder="请选择品类" :rules="[{ required: true, message: '品类不能为空' }]" @click="showPicker = true" readonly clickable/>
    <van-field v-model="registerReason" name="registerReason" label="登记原因" placeholder="请填写登记原因" :rules="[{ required: true, message: '登记原因不能为空' }]" :readonly="readonly"/>
    <van-field name="registerType" label="登记类型" :readonly="readonly">
      <template #input>
        <van-radio-group v-model="registerType" direction="horizontal">
          <van-radio :name="1">领取</van-radio>
          <van-radio :name="2">发放</van-radio>
        </van-radio-group>
      </template>
    </van-field>
    <van-field name="registerNum" label="登记数量" :readonly="readonly">
      <template #input>
        <van-stepper v-model="registerNum"/>
      </template>
    </van-field>
    <van-field :value="stockNum" name="stockNum" label="现有库存" readonly/>
    <van-field name="recordPeople" :value="recordPeople ? recordPeople : mobile" label="登记人员"/>
    <div v-if="!readonly" class="from-submit">
      <van-button round block type="info" native-type="submit">提交</van-button>
    </div>
    <van-popup v-if="!readonly" v-model="showPicker" position="bottom">
      <van-picker show-toolbar :columns="stockTypes" value-key="value" @confirm="pickerOnConfirm" @cancel="showPicker = false"/>
    </van-popup>
    <van-popup v-if="!readonly" v-model="showDatetimePicker" position="bottom">
      <van-datetime-picker type="datetime" :min-date="minDate" :max-date="maxDate" @confirm="datetimePickerOnConfirm" @cancel="showDatetimePicker = false" :formatter="datetimeFormatter"/>
    </van-popup>
  </van-form>
</template>

<style scoped>

</style>